import { Theme } from "@mui/material";
import { borderGeneralStyle } from "@utils/cssStyles";

export const getDropzoneBoxStyle = (theme: Theme, isDragActive: boolean) => ({
  border: "1px dashed",
  borderColor: isDragActive ? theme.palette.primary.main : theme.palette.text.borderLine,
  borderRadius: "12px",
  backgroundColor: isDragActive ? theme.palette.action.hover : theme.palette.background.neutral,
  padding: "32px 16px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: 1,
  transition: "all 0.2s ease-in-out",
});

export const getBrowseButtonStyle = (theme: Theme) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  textTransform: "none",
  borderRadius: "6px",
  fontWeight: 500,
  boxShadow: "none",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
    boxShadow: "none",
  },
  "&:disabled": {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
  },
});

export const fileListItemStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "8px 12px",
  ...borderGeneralStyle,
  borderRadius: "6px",
};

export const getUploadButtonStyle = (theme: Theme) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  textTransform: "none",
  borderRadius: "8px",
  fontWeight: 500,
  px: 2, 
  "&:hover": { backgroundColor: theme.palette.primary.dark },
  "&:disabled": {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
  },
});